import { render, staticRenderFns } from "./storeDangerPermit.vue?vue&type=template&id=fb18858e"
import script from "./storeDangerPermit.vue?vue&type=script&lang=js"
export * from "./storeDangerPermit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb18858e')) {
      api.createRecord('fb18858e', component.options)
    } else {
      api.reload('fb18858e', component.options)
    }
    module.hot.accept("./storeDangerPermit.vue?vue&type=template&id=fb18858e", function () {
      api.rerender('fb18858e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/dangerPermit/storeDangerPermit.vue"
export default component.exports